import addError from '../../../utils/error.jsx';

export function request({ old, password }) {
    return {
        type: 'USER_CHANGE_PASSWORD_REQUEST',
        password,
        old
    };
}

export function error(errors) {
    addError(errors);
    return {
        type: 'USER_CHANGE_PASSWORD_ERROR',
        errors
    };
}

export function finish() {
    return {
        type: 'USER_CHANGE_PASSWORD_FINISH'
    };
}

export function clear() {
    return {
        type: 'USER_CHANGE_PASSWORD_CLEAR'
    };
}
